import React, { useEffect, useImperativeHandle, useState } from 'react';
import { PropTypes } from 'prop-types';
import ChevronLeft from '@images/svg/ui/chevron-left.svg';

const Modal = React.forwardRef(({ children }, ref) => {
  const [modalOpen, setModalOpen] = useState(false);

  // Expose method to parent via ref
  useImperativeHandle(ref, () => ({
    open() {
      setModalOpen(true);
    },
    close() {
      setModalOpen(false);
    }
  }));

  // Make body overflow hidden, when modal is open
  useEffect(() => {
    document.body.setAttribute('data-has-modal', modalOpen ? 'true' : 'false');
  }, [modalOpen]);

  const modalClasses = ['c-modal', modalOpen && 'c-modal--open'].filter(Boolean);
  return (
    <div className={modalClasses.join(' ')}>
      <div className='c-modal__modal'>
        <div className='c-modal__container'>
          <div className='c-modal__close' onClick={() => setModalOpen(false)}>
            <ChevronLeft />
          </div>
          <div className='c-modal__content'>{children}</div>
        </div>
      </div>
      <div className='c-modal__backdrop' />
    </div>
  );
});

Modal.propTypes = {
  children: PropTypes.any
};

Modal.displayName = 'Modal';

export default Modal;
